export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/face.worker.9d4e4b6b.worker.js");
}
